import { Component, OnInit } from '@angular/core';

import { BoxGraphicStatisticService } from './box-graphic-statistic.service';

@Component({
  standalone: false,
  selector: 'box-graphic-statistic',
  templateUrl: './box-graphic-statistic.component.html',
  styleUrls: ['./box-graphic-statistic.component.css']
})
export class BoxGraphicStatisticComponent implements OnInit {

  infoStatistic: any;
  constructor(
    private boxGraphicStatisticService: BoxGraphicStatisticService
  ) { }

  ngOnInit() {
  }

}
